import articlesWithEmbeddings from '../jsons/articlesData.json'; 

const sortedArticles = articlesWithEmbeddings.sort((a, b) => {
  const dateA = new Date(a.date);
  const dateB = new Date(b.date);
  return dateB - dateA;
});

export default sortedArticles;